'use strict';

define('vb/action/builtin/checkForExtensionsAction',[
  'vb/action/action',
], (Action) => {
  /**
   * Check if extensions need to be downloaded from an extension manager. If the extensions have been previously
   * downloaded to the device, version check is performed to upgrade or download new extensions
   *
   * @param {Object} parameters Parameters passed to the action
   * @param {String} parameters.registryUrl The url for the Extension Registry Manager  (required)
   *
   * @returns {Promise<Outcome<Object>>} A Promise with an Outcome containing a literal object with property
   * "updateAvailable". The object property updateAvailable shall be true if there are extensions that
   * need to be downloaded, otherwise false. The result can be accessed in the action chain result using:
   * "$chain.results.[actionName].updateAvailable" for e.g."[[ $chain.results.checkForExtensions]].updateAvailable"
   *
   *
   * An example of entry to download extension in a page descriptor:
   *
   * "parameters": {
   *   "registryUrl": "https://fuscdrmsmc217-fa-ext.us.oracle.com:443/fscmUI/vxmanifest/v1/applications"
   * }
   *
   */
  class CheckForExtensionsAction extends Action {
    // eslint-disable-next-line class-methods-use-this
    perform(parameters) {
      return this.context.application.extensionRegistry.checkForExtensions(parameters.registryUrl)
        .then((extensions) => Action.createSuccessOutcome({ updateAvailable: !!(extensions && extensions.length > 0) }))
        .catch((e) => Action.createFailureOutcome('Failed to retrieve extensions', e));
    }

    setContext(context) {
      this.context = context;
    }
  }

  return CheckForExtensionsAction;
});

